<template>
    <v-layout row wrap align-start justify-end>
        <v-flex xs12 md8 lg8>
            <v-card style="border-radius: 20px;">
                <v-card-title>
                Pronostics
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="pronostics"
                  :search="search"
                >
                <template slot="items" slot-scope="props">
                    <td>
                          <v-tooltip right>
                            <kbd slot="activator">{{props.item.rank}}</kbd>
                            <v-card width="300">
                              <v-card-text>
                                <Viewer 
                                  :height="props.item.height"
                                  :gender="props.item.gender"
                                  :weight="props.item.weight"
                                  :date="props.item.date"
                                  :color="props.item.color" />
                              </v-card-text>
                            </v-card>
                          </v-tooltip>
                    </td>
                    <td>
                        {{ props.item.name }}
                    </td>
                    <td class="text-xs-right">{{ props.item.gender }}</td>
                    <td class="text-xs-right">{{ props.item.height }}</td>
                    <td class="text-xs-right">{{ props.item.weight }}</td>
                    <td class="text-xs-right">{{ props.item.date }}</td>
                    <td class="text-xs-right">{{ props.item.score }}</td>
                    <td v-if="isParent" class="text-xs-right">
                        <v-btn @click="$emit('delete', props.item.id)" icon>
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import Viewer from "@/components/baby/Viewer";

export default {
  props: {
    born: Object,
    users: Object,
    pronos: Array,
    isParent: Boolean
  },
  data() {
    return {
      search: ""
    };
  },
  computed: {
    headers() {
      let headers = [
        {
          text: "Rank",
          align: "center",
          sortable: true,
          value: "rank"
        },
        {
          text: "Participant",
          align: "left",
          sortable: true,
          value: "name"
        },
        { text: "Gender", value: "gender" },
        { text: "Height (cm)", value: "height" },
        { text: "Weight (g)", value: "weight" },
        { text: "date", value: "date" },
        { text: "score", value: "score", sortable: true }
      ];
      if (this.isParent) {
        headers.push({ text: "action", sortable: false })
      }
      return headers
    },
    pronostics() {
      return this.pronos
        .map(prono => {
          let author = this.users[prono.id];
          return {
            ...prono,
            date: this.convertDate(prono.date),
            author,
            name: author ? author.name : "",
            score: this.computeScore(prono),
            rank: 1
          };
        })
        .sort((a, b) => b.score - a.score)
        .map((prono, rank) => ({
          ...prono,
          rank: this.born ? rank + 1 : '?'
        }));
    }
  },
  methods: {
    convertDate(date) {
      return new Date(date.seconds * 1000).toISOString().split("T")[0];
    },
    computeScore(prono) {
      let score = 0;
      let closest;
      if (this.born) {
        // compute score
        // date
        if (
          this.isBest(prono, this.born, this.pronos, (prono, born) =>
            Math.abs(prono.date - born.date)
          )
        ) {
          if (prono.date === this.born.date) {
            score += 5;
          } else {
            score += 3;
          }
        }
        // height
        if (
          this.isBest(prono, this.born, this.pronos, (prono, born) =>
            Math.abs(prono.height - born.height)
          )
        ) {
          if (prono.height === this.born.height) {
            score += 3;
          } else {
            score += 1;
          }
        }
        // weight
        if (
          this.isBest(prono, this.born, this.pronos, (prono, born) =>
            Math.abs(prono.weight - born.weight)
          )
        ) {
          if (prono.weight === this.born.weight) {
            score += 3;
          } else {
            score += 1;
          }
        }
        // gender
        if (prono.gender === this.born.gender) {
          score += 3;
        }
        return score;
      } else {
        return "?";
      }
    },
    isBest(prono, born, pronos, predicat) {
      let closest = pronos.reduce(
        (min, p) => (predicat(p, born) < min ? predicat(p, born) : min),
        predicat(prono, born)
      );
      return closest === predicat(prono, born);
    }
  },
  components: {
    Viewer
  }
};
</script>